export default __webpack_public_path__ + "static/media/paint-03 (2).7c1e5634.jpg";